import { render, staticRenderFns } from "./BusinessBranchesList.vue?vue&type=template&id=4d0c4c73&"
import script from "./BusinessBranchesList.vue?vue&type=script&lang=js&"
export * from "./BusinessBranchesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports